<template>
  <case-file></case-file>
</template>

<script>
import CaseFile from '../components/case-file/index';

export default { components: { CaseFile } };

</script>
